import en from '../../messages/shopify-standalone/en.json';
import pl from '../../messages/shopify-standalone/pl.json';
import uk from '../../messages/shopify-standalone/uk.json';
import { shopifyPages } from './index';

const translations = { en, pl, uk };
const supportedLocales = ['en', 'pl', 'uk'];

const interpolate = (value, values) =>
  value.replace(/\{(topic|outcome)\}/g, (_, key) => values[key]);

function localizedContent(locale, slug) {
  const translation = translations[locale] || translations.en;
  const values = translation.pages[slug];
  const { copy, labels } = translation;
  return {
    title: interpolate(copy.title, values),
    description: interpolate(copy.description, values),
    heading: values.topic,
    intro: interpolate(copy.intro, values),
    category: labels.category,
    labels,
    sections: [
      {
        heading: copy.sectionOne,
        paragraphs: [
          interpolate(copy.sectionOneA, values),
          interpolate(copy.sectionOneB, values)
        ]
      },
      {
        heading: copy.sectionTwo,
        paragraphs: [
          interpolate(copy.sectionTwoA, values),
          interpolate(copy.sectionTwoB, values)
        ]
      },
      {
        heading: copy.sectionThree,
        paragraphs: [
          interpolate(copy.sectionThreeA, values),
          interpolate(copy.sectionThreeB, values)
        ]
      }
    ],
    example: {
      title: copy.exampleTitle,
      text: interpolate(copy.exampleText, values)
    },
    faqs: [
      { question: copy.faqOneQ, answer: copy.faqOneA },
      { question: copy.faqTwoQ, answer: copy.faqTwoA },
      { question: copy.faqThreeQ, answer: copy.faqThreeA }
    ],
    toolTitle: interpolate(copy.toolTitle, values)
  };
}

export const standalonePages = Object.keys(en.pages).map((slug) => ({ slug }));

export const standalonePage = (slug, locale = 'en') => {
  if (!standalonePages.some((page) => page.slug === slug)) return null;
  const content = localizedContent(locale, slug);
  const source = shopifyPages.find((page) => page.slug === slug);
  return {
    ...content,
    slug,
    tool: {
      ...source.tool,
      title: content.toolTitle,
      description: content.labels.note
    }
  };
};

export const standalonePath = (slug, locale = 'en') =>
  locale === 'en' ? `/${slug}` : `/${locale}/${slug}`;

export { supportedLocales };
